import React, { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { MyContext } from './MyContext';

const Header = () => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("accessToken")
    let userType = localStorage.getItem("userType")

    if (userType == "A") {
      navigate('/')
    }
    else if (userType == "I") {
      navigate('/institute')
    }
    else if (userType == "B") {
      navigate('/section')
    }

  }
  const { setSidebarToggle, sidebarToggle } = useContext(MyContext);



  const Funshow = () => {
    switch (localStorage.getItem("userType")) {
      case "I":
        return <>
          <li><img src={localStorage.getItem("logoPath")} alt="Institute Logo" /></li>
          <li className="nav-item"><span className="nav-link" href="#"><h3>{localStorage.getItem("instituteName")} ({localStorage.getItem("instituteId")}) </h3></span></li>
        </>

      case "A":
        return <>
          <li> <img src="https://api.examninja.co.in/images/1705820792167-939.jpeg" alt="Admin Logo" /></li>
          <li className="nav-item"><span className="nav-link" href="#"><h3>Next Gen Education </h3></span></li>
        </>

      case "B":
        return <>
          <li><img src={localStorage.getItem("logoPath")} alt="Section Logo" /></li>
          <li className="nav-item"><span className="nav-link" href="#"><h3>{localStorage.getItem("sectionName")} ({localStorage.getItem("sectionId")}) </h3></span>
            <h5>{localStorage.getItem("instituteName")} </h5>
          </li>
        </>

      default:
        break;
    }
  }

  return (
    <header className="header header-sticky mb-4">
      <div className="container-fluid">
        <button className="header-toggler px-md-0 me-md-3" type="button" onClick={() => setSidebarToggle(!sidebarToggle)}>
          <i class="fa-solid fa-bars"></i>
        </button>

        <span className="header-brand d-md-none" href="#">
          <svg width="118" height="46" alt="CoreUI Logo">
          </svg></span>
        <ul className="header-nav d-none d-md-flex">

          {Funshow()}

        </ul>
        <ul className="header-nav ms-3">
          <li className="nav-item dropdown" onClick={logout}><span className="nav-link py-0" data-coreui-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
            <div className="avatar avatar-md logout">
              Logout <i class="fa-solid fa-power-off"></i>
            </div></span>
            <div className="dropdown-menu dropdown-menu-end pt-0">
              <span className="dropdown-item" href="#">
                <svg className="icon me-2">
                </svg> Logout</span>
            </div>
          </li>
        </ul>
      </div>

    </header>
  )
};

export default Header;